<template>
    <div class="edit-profile-detail">
        <ProfileOptionSelector :model="'region'" :nextRoute="() => 'OnboardJobCategory'" />
    </div>
</template>

<script>
export default {
    name: 'Region',
}
</script>

<style scoped></style>
